import Image from "next/image"

import { Row } from "@/components/ui"
import { tv, type VariantProps } from "@/lib/utils/tv"

import appStoreBadge from "../../../../public/images/appStore.svg"
import googlePlayBadge from "../../../../public/images/googlePlay.svg"

const badge = tv({
  base: "w-auto",
  variants: {
    size: {
      sm: "h-9",
      md: "h-10",
      lg: "h-auto w-37.25",
    },
  },
  defaultVariants: { size: "md" },
})

interface StoreBadgesProps extends VariantProps<typeof badge> {
  className?: string
  links?: { ios?: string; android?: string }
}

const STORES = [
  { name: "Google Play", art: googlePlayBadge, platform: "android" as const },
  { name: "App Store", art: appStoreBadge, platform: "ios" as const },
]

export const StoreBadges = ({ size, className, links }: StoreBadgesProps) => {
  const styles = badge({ size })
  return (
    <Row gap="200" align="center" className={className}>
      {STORES.map((store) => {
        const art = <Image src={store.art} alt={store.name} className={styles} />
        const href = links?.[store.platform]
        return href ? (
          <a
            key={store.name}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="press focus-visible:ring-brand rounded-full focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
          >
            {art}
          </a>
        ) : (
          <span key={store.name}>{art}</span>
        )
      })}
    </Row>
  )
}
